import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43e34560"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Bookings", -1))
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" New Booking ")
const _hoisted_4 = { class: "search-form" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "From", -1))
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "To", -1))
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "form-group compact-field" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Dates", -1))
const _hoisted_13 = { class: "checkbox-label" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" All dates ")
const _hoisted_15 = { class: "form-group list-type-field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "List type", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 0,
  class: "form-group mode-field"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Mode (optional)", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Default", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "projected" }, "Projected", -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "search-with-submit" }
const _hoisted_24 = { class: "form-group search-field" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Guest Search (optional)", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "search-form-actions-spacer",
  "aria-hidden": "true"
}, " ", -1))
const _hoisted_27 = {
  key: 0,
  class: "field-hint field-hint--below-filters"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" For ")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "arrived", -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(", projected uses who should have arrived vs. who actually arrived. For ")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "arriving", -1))
const _hoisted_32 = /*#__PURE__*/_createTextVNode(", combine with arrived + projected if you need results limited to the date range (per Newbook). ")
const _hoisted_33 = [
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = { key: 3 }
const _hoisted_35 = { style: {"min-width":"900px"} }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Booking ID")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Guest")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Arrival")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Departure")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Status")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Total")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Balance")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Actions")
  ])
], -1))
const _hoisted_37 = { key: 1 }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 0,
  class: "pagination"
}
const _hoisted_40 = ["disabled"]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 4,
  class: "text-center"
}

import { onMounted, ref, watch } from "vue";
import api from "@virgodev/bazaar/functions/api";
import BaseSpinner from "@/components/BaseSpinner.vue";
import NewbookPaymentLinkModal from "@/components/NewbookPaymentLinkModal.vue";

interface BookingListRow {
  booking_id: string | number;
  guest_id?: string | number;
  guest?: NewbookGuestRow;
  guests?: NewbookGuestRow[];
  guest_name?: string;
  guest_firstname?: string;
  guest_lastname?: string;
  guest_email?: string;
  guest_phone?: string;
  guest_mobile?: string;
  booking_arrival: string;
  booking_departure: string;
  booking_status: string;
  booking_total?: string | number;
  total?: string | number;
  tariff_total?: string | number;
  calculated_total?: string | number;
  account_balance?: string | number;
  account_breakdown?: AccountBreakdownRow[];
}

interface AccountBreakdownRow {
  balance?: string | number;
}

interface NewbookGuestRow {
  guest_id?: string | number;
  id?: string | number;
  guest_name?: string;
  name?: string;
  guest_firstname?: string;
  guest_lastname?: string;
  firstname?: string;
  lastname?: string;
  primary_client?: string | number | boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    facilityId: null,
    facilityName: null
  },
  setup(__props: any) {

const props = __props as {
  facilityId: string;
  facilityName?: string;
}

const listTypeOptions: { value: string; label: string }[] = [
  { value: "all", label: "All" },
  { value: "arrived", label: "Arrived" },
  {
    value: "arriving",
    label: "Arriving",
  },
  { value: "cancelled", label: "Cancelled" },
  { value: "departed", label: "Departed" },
  { value: "departing", label: "Departing" },
  { value: "inhouse", label: "In-house — currently on site" },
  { value: "placed", label: "Placed" },
  { value: "staying", label: "Staying " },
  {
    value: "no_show",
    label: "No Show",
  },
  { value: "quoted", label: "Quoted" },
  { value: "waitlist", label: "Waitlist" },
];



const periodFrom = ref("");
const periodTo = ref("");
const allDates = ref(true);
const listType = ref("all");
const listMode = ref("");
const guestSearch = ref("");
const status = ref("idle");
const bookings = ref<BookingListRow[]>([]);
const errorMessage = ref("");
const dataOffset = ref(0);
const dataLimit = ref(100);
const dataTotal = ref(0);
const paymentLinkBookingId = ref<string | number | null>(null);

watch(listType, (v) => {
  if (v !== "arrived" && v !== "arriving") {
    listMode.value = "";
  }
});

onMounted(() => {
  const today = new Date();
  periodFrom.value = today.toISOString().slice(0, 10);
  const nextMonth = new Date(today);
  nextMonth.setMonth(nextMonth.getMonth() + 1);
  periodTo.value = nextMonth.toISOString().slice(0, 10);
  loadBookings();
});

function runListSearch() {
  dataOffset.value = 0;
  loadBookings();
}

function openPaymentLink(bookingId: string | number) {
  paymentLinkBookingId.value = bookingId;
}

async function loadBookings() {
  errorMessage.value = "";
  status.value = "loading";
  bookings.value = [];

  const params: Record<string, string> = {
    facilityId: props.facilityId,
    data_offset: String(dataOffset.value),
    data_limit: String(dataLimit.value),
  };
  if (listType.value !== "inhouse" && !allDates.value) {
    if (periodFrom.value) params.period_from = periodFrom.value + " 00:00:00";
    if (periodTo.value) params.period_to = periodTo.value + " 23:59:59";
  }
  if (listType.value) params.list_type = listType.value;
  if (listMode.value) params.mode = listMode.value;
  const sq = guestSearch.value.trim();
  if (sq) params.search = sq;

  try {
    const qs = new URLSearchParams(params).toString();
    const response = await api({
      url: `nb/bookings/?${qs}`,
      method: "GET",
    });

    if (response.ok) {
      bookings.value = (response.body.data || []) as BookingListRow[];
      dataTotal.value = response.body.data_total || bookings.value.length;
    } else {
      const body = "body" in response ? response.body : undefined;
      errorMessage.value = body?.error || "Failed to load bookings.";
    }
  } catch {
    errorMessage.value = "An error occurred while loading bookings.";
  }

  status.value = "loaded";
}

function prevPage() {
  dataOffset.value = Math.max(0, dataOffset.value - dataLimit.value);
  loadBookings();
}

function nextPage() {
  dataOffset.value += dataLimit.value;
  loadBookings();
}

function primaryGuest(booking: BookingListRow): NewbookGuestRow | null {
  if (booking.guest) return booking.guest;
  if (Array.isArray(booking.guests) && booking.guests.length) {
    return (
      booking.guests.find((guest) =>
        ["1", "true", "yes"].includes(
          String(guest.primary_client).toLowerCase()
        )
      ) || booking.guests[0]
    );
  }
  if (booking.guest_id) return booking;
  return null;
}

function primaryGuestId(booking: BookingListRow) {
  const guest = primaryGuest(booking);
  return guest?.guest_id || guest?.id || booking.guest_id || "";
}

function primaryGuestName(booking: BookingListRow) {
  const guest = primaryGuest(booking);
  const first = guest?.guest_firstname || guest?.firstname || "";
  const last = guest?.guest_lastname || guest?.lastname || "";
  return (
    guest?.guest_name ||
    guest?.name ||
    [first, last].filter(Boolean).join(" ") ||
    `Guest ${primaryGuestId(booking)}`
  );
}

function formatDate(dt: string) {
  if (!dt) return "-";
  return dt.slice(0, 10);
}

function bookingTotal(booking: BookingListRow) {
  return firstMeaningfulAmount(
    booking.booking_total,
    booking.total,
    booking.tariff_total,
    booking.calculated_total
  );
}

function bookingBalance(booking: BookingListRow) {
  return firstMeaningfulAmount(
    booking.account_balance,
    accountBreakdownTotal(booking.account_breakdown),
    bookingTotal(booking)
  );
}

function firstMeaningfulAmount(
  ...values: Array<string | number | null | undefined>
) {
  const fallback = values.find(
    (value) => value !== null && value !== undefined && value !== ""
  );
  const nonZero = values.find((value) => {
    if (value === null || value === undefined || value === "") return false;
    const amount = numericAmount(value);
    return Number.isFinite(amount) && amount !== 0;
  });
  return nonZero ?? fallback ?? null;
}

function accountBreakdownTotal(
  breakdown: AccountBreakdownRow[] | null | undefined
) {
  if (!Array.isArray(breakdown) || !breakdown.length) return null;
  return breakdown.reduce((total, item) => {
    const amount = numericAmount(item.balance || 0);
    return Number.isFinite(amount) ? total + amount : total;
  }, 0);
}

function money(value: string | number | null | undefined) {
  if (value === null || value === undefined || value === "") return "-";
  const amount = numericAmount(value);
  if (!Number.isFinite(amount)) return String(value);
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
}

function numericAmount(value: string | number) {
  return Number(String(value).replace(/[^0-9.-]/g, ""));
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RouterLink, {
        class: "btn btn-blue",
        to: {
        name: 'nb_availability',
        params: { facilityId: __props.facilityId, facilityName: __props.facilityName },
      }
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((periodFrom).value = $event)),
            type: "date",
            disabled: listType.value === 'inhouse' || allDates.value
          }, null, 8, _hoisted_7), [
            [_vModelText, periodFrom.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((periodTo).value = $event)),
            type: "date",
            disabled: listType.value === 'inhouse' || allDates.value
          }, null, 8, _hoisted_10), [
            [_vModelText, periodTo.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("label", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((allDates).value = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, allDates.value]
            ]),
            _hoisted_14
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((listType).value = $event)),
            class: "form-select"
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(listTypeOptions, (opt) => {
              return _createElementVNode("option", {
                key: opt.value,
                value: opt.value
              }, _toDisplayString(opt.label), 9, _hoisted_17)
            }), 64))
          ], 512), [
            [_vModelSelect, listType.value]
          ])
        ]),
        (listType.value === 'arrived' || listType.value === 'arriving')
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _hoisted_19,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((listMode).value = $event)),
                class: "form-select"
              }, _hoisted_22, 512), [
                [_vModelSelect, listMode.value]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((guestSearch).value = $event)),
              type: "text",
              placeholder: "Name, Phone, Email",
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, guestSearch.value]
            ])
          ]),
          _createElementVNode("div", { class: "form-group form-group--search-actions" }, [
            _hoisted_26,
            _createElementVNode("button", {
              id: "bookings-search-submit",
              class: "btn btn-blue",
              type: "button",
              onClick: runListSearch
            }, " Search ")
          ])
        ])
      ]),
      (listType.value === 'arrived' || listType.value === 'arriving')
        ? (_openBlock(), _createElementBlock("p", _hoisted_27, _hoisted_33))
        : _createCommentVNode("", true),
      (status.value === 'loading')
        ? (_openBlock(), _createBlock(BaseSpinner, {
            key: 1,
            preset: "large"
          }))
        : _createCommentVNode("", true),
      (errorMessage.value)
        ? (_openBlock(), _createBlock(_component_BaseAlert, {
            key: 2,
            variant: "danger",
            dismissible: "",
            onDismissed: _cache[6] || (_cache[6] = ($event: any) => (errorMessage.value = ''))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(errorMessage.value), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (status.value === 'loaded' && bookings.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createElementVNode("table", _hoisted_35, [
              _hoisted_36,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookings.value, (booking) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: booking.booking_id
                }, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: {
                name: 'nb_booking_detail',
                params: {
                  bookingId: booking.booking_id,
                  facilityId: __props.facilityId,
                  facilityName: __props.facilityName,
                },
              }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(booking.booking_id), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createElementVNode("td", null, [
                    (primaryGuestId(booking))
                      ? (_openBlock(), _createBlock(_component_RouterLink, {
                          key: 0,
                          to: {
                name: 'nb_guest_detail',
                params: {
                  guestId: primaryGuestId(booking),
                  facilityId: __props.facilityId,
                  facilityName: __props.facilityName,
                },
              }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(primaryGuestName(booking)), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_37, "-"))
                  ]),
                  _createElementVNode("td", null, _toDisplayString(formatDate(booking.booking_arrival)), 1),
                  _createElementVNode("td", null, _toDisplayString(formatDate(booking.booking_departure)), 1),
                  _createElementVNode("td", null, _toDisplayString(booking.booking_status), 1),
                  _createElementVNode("td", null, _toDisplayString(money(bookingTotal(booking))), 1),
                  _createElementVNode("td", null, _toDisplayString(money(bookingBalance(booking))), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      class: "btn btn-sm",
                      type: "button",
                      onClick: ($event: any) => (openPaymentLink(booking.booking_id))
                    }, " Payment ", 8, _hoisted_38)
                  ])
                ]))
              }), 128))
            ]),
            (dataTotal.value > bookings.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("button", {
                    class: "btn",
                    disabled: dataOffset.value === 0,
                    onClick: prevPage
                  }, " Previous ", 8, _hoisted_40),
                  _createElementVNode("span", null, " Showing " + _toDisplayString(dataOffset.value + 1) + "-" + _toDisplayString(dataOffset.value + bookings.value.length) + " of " + _toDisplayString(dataTotal.value), 1),
                  _createElementVNode("button", {
                    class: "btn",
                    disabled: dataOffset.value + bookings.value.length >= dataTotal.value,
                    onClick: nextPage
                  }, " Next ", 8, _hoisted_41)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (status.value === 'loaded')
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, " No bookings found. "))
          : _createCommentVNode("", true),
      (paymentLinkBookingId.value)
        ? (_openBlock(), _createBlock(NewbookPaymentLinkModal, {
            key: 5,
            "booking-id": paymentLinkBookingId.value,
            "facility-id": __props.facilityId,
            onModalClosed: _cache[7] || (_cache[7] = ($event: any) => (paymentLinkBookingId.value = null))
          }, null, 8, ["booking-id", "facility-id"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})